if (!customElements.get('shrink-element')) {
  customElements.define(
    'shrink-element',
    class ShrinkElement extends HTMLElement {
      constructor() {
        super();

        this.CLASSES = {
          shrinkClass: 'shrink-element--is-shrinked',
        };

        this.element = document.querySelector(`[js-shrink-element-key="${this.key}"]`);

        window.addEventListener('scroll', this.handleScroll.bind(this));
      }

      handleScroll() {
        if (!this.element) return;

        const elementRect = this.element.getBoundingClientRect();
        const elementBottom = elementRect.bottom + this.offsetHeight;

        if (elementBottom <= window.innerHeight) {
          this.classList.add(this.CLASSES.shrinkClass);
        } else {
          this.classList.remove(this.CLASSES.shrinkClass);
        }
      }

      get key() {
        return this.dataset.key;
      }
    },
  );
}
